import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { PrintFile } from '../product';

@Injectable({ providedIn: 'root' })
export class UploadDbService extends FirestoreBase<PrintFile> {
  constructor(firestore: Firestore) {
    super('uploads', firestore);
  }
}
